import {
  useCompanyFilter,
  useDepartmentFilter,
  useLegalEntityFilter,
} from '../../../modules/components/table/filters/CompanyFilter';

export const useFilters = () => {
  return [useCompanyFilter(), useLegalEntityFilter(), useDepartmentFilter()];
};
